import { render, staticRenderFns } from "./averageScore.vue?vue&type=template&id=039a3f0a&scoped=true"
import script from "./averageScore.vue?vue&type=script&lang=js"
export * from "./averageScore.vue?vue&type=script&lang=js"
import style0 from "./averageScore.vue?vue&type=style&index=0&id=039a3f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a3f0a",
  null
  
)

export default component.exports